import Vue from 'vue'
import router from './routes.js'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    loginActive: false,
    failedLogin: false,
    askForPass: false,
    step: -1,
    idStep: 0,
    usr: {
        gid: null, // Number,
        email: null,
        name: null,
        entity: null,
        registerDate: null,
        logueado: false
    },
    evento: {
        ide: null, //Number,
    },
    regForm: {},
    regComplete: -1, //-1: No se grabó nada aún | 0: Error al grabar | 1: Grabado ok
    strpUsrPay : {
      clientSecret: null,
      tax: 0
    }
  },
  mutations: {
    resetEvent(state) {
      state.evento = {}
    },
    updateEvent(state, ev) {
      state.evento = ev;

       // Cargar los colores personalizados en las variables CCS
      // console.log(this.$store.state.evento_detalles.usaColoresPersonalizados)
      if (state.evento.iqPrimary !== '') {
        document.documentElement.style.setProperty('--iq-primary', state.evento.iqPrimary)
        document.documentElement.style.setProperty('--iq-primary-light', state.evento.iqPrimaryLight)
        document.documentElement.style.setProperty('--iq-primary-dark', state.evento.iqPrimaryDark)
      } else {
        document.documentElement.style.setProperty('--iq-primary', '#932852')
        document.documentElement.style.setProperty('--iq-primary-light', '#dc3545')
        document.documentElement.style.setProperty('--iq-primary-dark', '#932852')
      }
      // state.evento.ide = ev.idEvento;
      // state.evento.logoPlataforma = ev.LogoPlataforma;
      // state.evento.virtual=ev.RONDA_VIRTUAL;
      // state.evento.custom_translate=ev.custom_translate;
      // state.evento.tieneCosto = ev.TieneCosto;
      // state.evento.userPago = ev.Pago;
      // state.evento.userInvitado = ev.Invitado;
      // state.evento.permiteCoordinarAPendPago = ev.permitir_coordinar_a_pendientes_pago;
      // state.evento.solicitarReuniones = ev.solicitar_reuniones;
      // state.evento.coordinaTurnos = ev.coordina_turnos;
      // state.evento.dialogo_indica_objetivo_reunion = ev.dialogo_indica_objetivo_reunion;
      // state.evento.tieneEncuesta = ev.tieneEncuesta;
      // state.evento.UserFechaDesde = ev.UserFechaDesde;
      // state.evento.UserFechaHasta = ev.UserFechaHasta;
      // state.evento.UserFechaCierreCordinacionReuniones = ev.UserFechaCierreCordinacionReuniones;
      // state.evento.UserFechaAperturaCordinacionReuniones = ev.UserFechaAperturaCordinacionReuniones;
      // state.evento.ProhibeListar = ev.ProhibeListar;
      // state.evento.CoordinacionReunionesACargoOrganizador = ev.CoordinacionReunionesACargoOrganizador;
      // state.evento.status_coordinacion_reuniones = ev.status_coordinacion_reuniones;
      // state.participante.max_reuniones_hard = ev.max_reuniones_hard;
      // state.participante.max_solicitudes = ev.max_solicitudes;
      // state.participante.UserTimeZoneName = ev.UserTimeZoneName;
      // state.participante.cant_le_pidieron_aceptadas = ev.cant_le_pidieron_aceptadas;
      // state.participante.cant_le_pidieron_pendientes = ev.cant_le_pidieron_pendientes;
      // state.participante.cant_le_pidieron_rechazadas_o_canceladas = ev.cant_le_pidieron_rechazadas_o_canceladas;
      // state.participante.cant_pedidas_aceptadas = ev.cant_pedidas_aceptadas;
      // state.participante.cant_pedidas_pendientes = ev.cant_pedidas_pendientes;
      // state.participante.cant_pedidas_rechazadas_o_canceladas = ev.cant_pedidas_rechazadas_o_canceladas;
      // state.participante.cant_reuniones_en_agenda = ev.cant_reuniones_en_agenda;
    },
    clearUsrData (state, email) {
      state.usr.gid = null
      state.usr.email = email
      state.usr.name = null
      state.usr.entity = null
      state.usr.logueado = false
      state.askForPass = false
      state.usr.registerDate = null
      state.step = -1
      state.idStep = 0,
      state.regForm = {
        email: {
          fid: "8",
          fname: "email",
          fvalue: email }
      }
      // state.evento = {
      //   ide: null
      // }
    },
    updateUsrData (state, data) {
      //alert('Entró a mutar')
      if (state.usr.gid == data.id){
        state.usr.email = data.email
        state.usr.name = data.personName
        state.usr.entity = data.detalles.nombre
      } else {
        state.usr.gid = data.id
        state.usr.email = data.email
        state.usr.name = data.personName
        state.usr.entity = null
        state.usr.logueado = false
      }
      
      // state.regForm.email.fvalue = data.email
      // state.regForm.personName.fvalue = data.detalles.nombreapellido
      // // alert(state.regForm.entity.fvalue)
      // // alert(data.detalles.empresa)
      // state.regForm.entity.fvalue = data.detalles.empresa
      // // alert(state.regForm.entity.fvalue)
      // state.regForm.cargo.fvalue = data.detalles.puesto
      // state.regForm.sector.fvalue = data.detalles.actividad
      // state.regForm.address.fvalue = data.detalles.direccion
      // state.regForm.city.fvalue = data.detalles.ciudad
      // state.regForm.provincia.fvalue = data.detalles.provincia
      // state.regForm.celular.fvalue = data.detalles.celular
      // state.regForm.telefono.fvalue = data.detalles.telefono
      // state.regForm.pais.fvalue = data.detalles.pais
      // state.regForm.website.fvalue = data.detalles.web
      // state.regForm.ofrece.fvalue = data.detalles.ofrece
      // state.regForm.demanda.fvalue = data.regForm.demanda
      // "thumb", "avatar", "lenguaje"
    },
    askForPass (state, ask){
      state.askForPass = ask
    },
    loginActive (state, active) {
      state.loginActive = active
    },
    login(state, datosUsr) {
      state.usr.gid = datosUsr.datos.id
      state.usr.email = datosUsr.datos.email
      state.usr.name = datosUsr.datos.PersonName
      state.usr.entity = datosUsr.datos.name
      //state.usr.avatar = datosUsr.datos.avatar
      state.usr.registerDate = datosUsr.datos.registerDate
      // state.usr.lastvisitDate = datosUsr.datos.lastvisitDate
      state.usr.logueado = true
      state.askForPass = false
      // state.usr.timeout = false
    },
    nextStep (state, idStep){
      // console.log('nextStep' + idStep)
      state.step = state.step + 1
      state.idStep = idStep
    },
    backStep (state){
      state.step = state.step - 1
    },
    failedLogin(state, fallo) {
      state.failedLogin = fallo
      state.usr.logueado = false
      state.askForPass = true
      //state.usr.timeout = false
    },
    appendToRegForm (state, payload) {
      for(const [, value] of Object.entries(payload)){
      // for(const [key, value] of Object.entries(payload)){
        // console.log(key)
          Object.defineProperty(state.regForm, value.fname , {
              enumerable: true,
              configurable: true,
              writable: true,
              value: value
            })
      }
    },
    regFinished (state, payload) {
      // console.log('Fin del registro')
      // console.log(payload.ide)
        const that=this
        const axios = require("axios") // eslint-disable-line
        var url = Vue.prototype.$websiteGlobiz + "/api/json-reg-crear-cuenta.php"
        axios
          .post(url, {
            dev: !(process.env.NODE_ENV === "production"), // eslint-disable-line
            appid: 1,
            lang: payload.lang,
            ide: payload.ide ,
            pli: payload.pli ,
            objR: state.evento.objetivo_ronda,
            keyB: state.evento.KeyBuyer,
            gid: state.usr.gid,
            form: state.regForm 
          })
          .then(function (response) {
            if (response.data.error == '' || response.data.error == 0) {
                state.regComplete = 1
                var det
                if (state.regForm.entidad) {
                  det = {nombre: state.regForm.entidad.fvalue}
                } else {
                  det = {}
                }
                var datosUsr = {
                  id: response.data.gid,
                  email: state.regForm.email.fvalue,
                  PersonName: state.regForm.personName.fvalue,
                  detalles: det
                }
                that.commit('updateUsrData', datosUsr)

                //Si el evento tiene costo, y el módulo de cobranza está activo
                if (that.state.evento.TieneCosto == '1' && that.state.evento.ModuloCobranzaActivo == '1') {
                  router.push({ name: 'order' })
                }
                else {
                  if (that.state.evento.url_salida_web_evento && that.state.evento.url_salida_web_evento !=='' ) {
                    let urlLanding = that.state.evento.url_salida_web_evento
                    window.location.replace(urlLanding)
                  } else {
                    router.push({ name: 'blank' })
                    // codigo q detecta si corre en un iframe 
                    // if (isset($_SERVER['HTTP_SEC_FETCH_DEST']) && $_SERVER['HTTP_SEC_FETCH_DEST'] == 'iframe') {
                    //   $target = ' target="_blank "';
                    // } else {
                    //   $target = ' ';
                    // } ?>
                  }
                }
            } else {
                state.regComplete = 0
            }
          })
          .catch(function (error) {
            console.log(error)
          })
    },
    updateStrpUsrPay (state, payload) {
      state.strpUsrPay.secret = payload.secret
      state.strpUsrPay.tax = payload.tax
    }
  },
  actions: {
    login(context, datosLogin) {
      // var that = this
      const axios = require('axios'); // eslint-disable-line
      var url = this._vm.$websiteFront + '/api/access-appw-rdn.php';
      axios
        .post(url, {
          username: datosLogin.username,
          passwd: datosLogin.passwd,
          ide: datosLogin.ide,
        })
        .then(function (response) {
          // console.log(response);
          if (response.data.logueado == '1') {
            //Ok - Guarda en store datos del usuario
            context.commit('login', response.data);
            // that.$emit('change-next', {value: true})
            // router.push({
            //   name: 'registro',
            //   params: {
            //     ide: 158, // that.$route.params.ide,
            //     pli: 292, // that.$route.params.pli,
            //     step: 1
            //   },
            // });
          } else {
            //Presenta notificación fallo
            context.commit('failedLogin', true);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    failedLogin(context, fallo) {
      context.commit('failedLogin', fallo);
    },
    activarDialogoLogout(state) {
      state.dialogoLogout = true;
    },
    desactivarDialogoLogout(state) {
      state.dialogoLogout = false;
    },
    async checkout(state, payload) {
      // state.strpUsrPay.clientSecret =
      // state.strpUsrPay.tax = 
      state.strpUsrPay.paymentID = payload
    }
  },
  plugins: [
    createPersistedState({
      key: 'reg-appw',
      paths: ['usr', 'evento', 'regForm']})
    ]
})